import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex w-full items-center" }

import Breadcrumbs from '@/components/Breadcrumbs.vue';
    import type { BreadcrumbItemType } from '@/types';
    import Card from '@/components/ui/card/Card.vue';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebarHeader',
  props: {
    breadcrumbs: { default: () => [] },
    headerClass: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { class: "z-10 mx-1.5 mt-1.5 flex min-h-12 flex-row items-center px-5" }, {
    default: _withCtx(() => [
      _createElementVNode("header", {
        class: _normalizeClass(_unref(cn)('overflow-hidden', _ctx.headerClass))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.breadcrumbs && _ctx.breadcrumbs.length > 0)
            ? (_openBlock(), _createBlock(Breadcrumbs, {
                key: 0,
                breadcrumbs: _ctx.breadcrumbs
              }, null, 8, ["breadcrumbs"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "actions")
        ])
      ], 2)
    ]),
    _: 3
  }))
}
}

})